import { useTranslation } from 'react-i18next';
import { AdditionalInformationStep } from '../../../api/screening/findOverview';
import ScreeningOverviewStepTable from './ScreeningOverviewStepTable';

interface ScreeningOverviewAdditionalInformationStepTableProps {
    data: AdditionalInformationStep['data'];
}

const ScreeningOverviewAdditionalInformationStepTable = ({
    data
}: ScreeningOverviewAdditionalInformationStepTableProps) => {
    const { t } = useTranslation();

    const additionalInformationStepData = [
        {
            subSections: [
                {
                    title: t('screening.overview.step.additionalInformation.additionalComments'),
                    value: data.additionalComments,
                    optional: true,
                },
                {
                    title: t('screening.overview.step.additionalInformation.uploadedDocuments'),
                    data: [
                        {
                            title: t('screening.additionalInformation.landlordsStatement.label'),
                            optional: true,
                            value: data.landlordsStatement
                        },
                        {
                            title: t('screening.additionalInformation.extraDocuments.label'),
                            optional: true,
                            value: data.extraDocuments
                        }
                    ]
                },
            ]
        }
    ];

    return (
        <ScreeningOverviewStepTable
            data={additionalInformationStepData}
        />
    );
}

export default ScreeningOverviewAdditionalInformationStepTable;
